<template lang="pug">
  div
    v-card.mb-3
      v-card-title.grey.lighten-4
        a.title(v-if="extra.options && extra.options.title_url" :href="extra.options.title_url") {{extra.name}}
        .title(v-else) {{extra.name}}
      video-player.wrap-aspect.ratio-16-9(ref="player" :options="currentVideo" @ended="ended")
      div
        template(v-for="video, i in videos")
          v-divider
          .px-3.py-2.d-flex.align-center
            .pr-3(v-if="video.thumb")
              img.content-img(:src="video.thumb")
            a(@click="playVideo(i)") {{video.title}}

</template>

<style lang="stylus" scoped>
.content-img
  width 60px
  height auto
</style>


<script>
export default {
  props: ['extra'],
  data() {
    return {
      currentIndex: 0,
      playNext: false,
    }
  },
  computed: {
    currentVideo() {
      return this.videos[this.currentIndex]
    },
    videos() {
      if (this.extra && this.extra.content) {
        const videos = JSON.parse(this.extra.content)
        videos.forEach(video => { video.techOrder = ["html5", "Youtube"] })
        return videos
      } else {
        return [] 
      }
    }
  },
  methods: {
    playVideo(i) {
      this.currentIndex = i
      window.p = this
    },
    ended(player) {
      if (this.playNext && this.currentIndex + 1 < this.videos.length) {
        this.currentIndex++
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.player && this.$refs.player.player) {
              this.$refs.player.player.play()
            }
          })
        }, 500)
      }
    }
  }
}
</script>
